import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { IoChevronBackCircleOutline } from "react-icons/io5";
import instance from "../../api/api";
// import Input from "../../features/Input";
import Button from "../../features/Button";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import Spinner from "react-bootstrap/Spinner";
// import Table from "react-bootstrap/Table";
import { Tabs } from "antd-mobile";
// import {Help} from "../../utils"
import { Avatar } from 'primereact/avatar';
// import { Badge } from 'primereact/badge';
import { Rate } from 'antd';

function NoteAndAvis() {
  const navigate = useNavigate();
  const { id,name } = useParams();
  const [detailPersonnel, setDetailPersonnel] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    const getNoteAndAvis = async () => {
      try {
        const response = await instance.get(`/reservations/${id}`);
        console.log(response);
        const coupons = response.data.data;
        setDetailPersonnel(coupons);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
      }
    };
    getNoteAndAvis();
  }, [id]);
  return (
    <div className="detail-student">
      <div className="back-user">
        <IoChevronBackCircleOutline
          className="back-home"
          onClick={() => {
            navigate(-1);
          }}
        />

        <h5>
          <span className="text-primary">Réservations de : </span>   {name}
        </h5>
      </div>
      {
        detailPersonnel &&  
        <div className="p-3">
        <p>Nom & prénoms du client : {detailPersonnel.user.nom} {detailPersonnel.user.prenoms} </p> 
         <p>Date et heure du rendez-vous : {detailPersonnel.date} à {detailPersonnel.heure}</p> 
         <p>Heure début du service : {detailPersonnel.date_debut ? detailPersonnel.date_debut:'.....'}</p> 
         <p>Heure fin du service : {detailPersonnel.date_fin ? detailPersonnel.date_fin:'.....'}</p> 
         <p>Montant du service : {detailPersonnel.montant} Fcfa </p> 
         <p>Durée du service : {detailPersonnel.service.duree} heure</p> 
         <div>
         <div className="d-flex">
         <h1>Note & avis </h1>
          <h2 className="mx-2">{detailPersonnel.notes.length > 0 ? `(${detailPersonnel.notes.length} commentaire)`:""}</h2>
         </div>
          {
            detailPersonnel.notes.map(item=>(
              <>
              <div key={item.id}>
                <div className="d-flex">
                <h3 className="mx-1">{item.rate}</h3>
                <h5>/5</h5>
                </div>
               
                <div className="commentaire">
                
               <h6>
               <Avatar icon="pi pi-user" className="mr-2" size="large" />
                {item.user.nom} {item.user.prenom}</h6>
                <Rate disabled defaultValue={item.rate} />
               <span>{item.commentaire}</span>
                </div>
             
              </div>
            
            </>
            ))
            
            }
            {
              !detailPersonnel.notes.length && 
            <h6>Pas de notes et avis</h6>
            }
         
         </div>
        </div>
      }
     
    </div>
  );
}


export default NoteAndAvis;
